import React,{useState} from 'react';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


const Confirmation =(props)=> {
  const {handleClose, action, actionName, message, title, children} = props

  const onAction = ()=>{
    action()
    handleClose()
  }

  return (
  <>
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message} ?</DialogContentText>
        {
          children && children
        }               
      </DialogContent>
      <DialogActions>
        <Button  onClick={onAction} color="secondary">
          {actionName}
        </Button>
        <Button variant="contained" onClick={handleClose} color="primary">
          Batal
        </Button>
      </DialogActions>
  </>

    );
}

export default Confirmation;
